import React from 'react';
import UserManagement from '../../pages/UserManagement';

// Wrapper component to embed UserManagement page in admin dashboard
const UsersTab = () => {
  return (
    <div className="users-tab">
      <UserManagement />
    </div>
  );
};

export default UsersTab;
